// extracted by mini-css-extract-plugin
module.exports = {"s1to8d98":"s1to8d98","s1ssv40s":"s1ssv40s","s18gqkxv":"s18gqkxv","sxyykz6":"sxyykz6","s1j55jon":"s1j55jon"};